// extracted by mini-css-extract-plugin
export default {"textList":"Text_textList__MkNPP"};